import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F789CE44-7EA3-4E97-88FB-BEC22EB2030C
 * name check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check.svg
 * tags
 * - Form 
 */
export const CheckIcon = createSvgIcon(<><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></>, 'CheckIcon');
export default CheckIcon